export default {"src":"/_next/static/media/powered-by-goodlife.e3c29692.svg","height":16,"width":170,"blurWidth":0,"blurHeight":0};